var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress-steps"},_vm._l((_vm.steps),function(step,index){return _c('div',{key:index,class:[
      'step',
      { active: index < _vm.currentStep - 1, current: index === _vm.currentStep - 1 } ]},[_c('div',{staticClass:"step-circle"},[_c('span',{staticClass:"step-title"},[_vm._v(_vm._s(step))])]),(index < _vm.steps.length - 1)?_c('div',{staticClass:"step-line"}):_vm._e()])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }